var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav__tabs",style:({ 'background-color': _vm.props.colors.tab.background })},_vm._l((_vm.props.links),function(ref){
var name = ref.name;
var link = ref.link;
var title = ref.title;
return _c('router-link',{key:name,staticClass:"nav__tab",style:({
        'background-color': _vm.$route.name === name ? _vm.props.colors.activeTab.background : '',
        color: _vm.$route.name === name ? _vm.props.colors.activeTab.text : _vm.props.colors.tab.text
      }),attrs:{"to":link}},[_vm._v(" "+_vm._s(title)+" ")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }